import request from '@/utils/request'

// H5页面活动相关奖品数据获取
export function getActivityDetail(activityId) {
  return request({
    url: SEVSRS + `/activity/v1/info/${activityId}`,
    method: 'get'
  })
}
// H5页面积分中心数据获取
export function getAppintegral(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/info`,
    method: 'get',
    params
  })
}
// H5积分抽奖动态
export function getWinners(params) {
  return request({
    url: SEVSRS + `/prize/v1/winners`,
    method: 'get',
    params
  })
}
// H5页面积分中心签到
export function integralSignIn(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/signIn`,
    method: 'get',
    params
  })
}
// H5页面活动用户抽奖
export function activityDraw(data) {
  return request({
    url: SEVSRS + `/activity/v1/app/draw`,
    method: 'post',
    data
  })
}
// H5页面积分及中奖记录
export function integralRecord(params) {
  return request({
    url: SEVSRS + `/integral/v1/app/integral-record`,
    method: 'get',
    params
  })
}
// H5核销验证码获取
export function getCode(params) {
  return request({
    url: SEVSRS + `/user/v1/app/pin`,
    method: 'get',
    params
  })
}
// H5核销验证码校验及中奖信息获取
export function getExchangeInfo(params) {
  return request({
    url: SEVSRS + `/prize/v1/exchange-info`,
    method: 'get',
    params
  })
}
// H5获取二维码接口
export function getCodeInfo(params) {
  return request({
    url: SEVSRS + `/files/v1/app/qr-code`,
    method: 'get',
    params
  })
}
// H5获奖名单手动核销
export function appManualOff(id) {
  return request({
    url: SEVSRS + `/activity/v1/app/manual/${id}`,
    method: 'get',
  })
}
// H5获取全部疾病数据
export function medicalcanonv1info(id) {
  return request({
    url: SEVSRS + `/medical-canon/v1/info?broadHeading=1`,
    method: 'get',
  })
}
// H5获取全部疾病详情
export function illnessdetail(name) {
  return request({
    url: SEVSRS + `/medical-canon/v1/illness-detail?typeName=${name}`,
    method: 'get',
  })
}
// H5获取全部疾病筛选
export function illnessall(name) {
  return request({
    url: SEVSRS + `/medical-canon/v1/illness-all`,
    method: 'get',
  })
}
// 京东购买
export function skipstore(name) {
  return request({
    url: SEVSRS + `/jd/v1/skip-store`,
    method: 'get',
  })
}
// 咨询列表
export function appnews() {
  return request({
    url: SEVSRS + `/study/v1/app/news?typeId=2`,
    method: 'get',
  })
}
// 用户查看是否有权益
export function equityinfo(data) {
  return request({
    url: SEVSRS + `/equity/v2/info?code=0001`,
    method: 'get',
  })
}
// 提交
export function assistsendemail(data) {
  return request({
    url: SEVSRS + `/outpatient/v1/assist-send-email`,
    method: 'post',
    data
  })
}
export function flag(name) {
  return request({
    url: SEVSRS + `/common/v1/service-click-add?flag=` + name,
    method: 'get',
  })
}
// 获取验证码
export function pin(name) {
  return request({
    url: SEVSRS + `/user/v1/app/pin?phone=` + name,
    method: 'get',
  })
}
// 登录
export function login(data) {
  return request({
    url: SEVSRS + `/user/v1/app/login?phone=` + data.phone + '&pin=' + data.authCode,
    method: 'get',
  })
}
// 注册
export function register(data) {
  return request({
    url: SEVSRS + `/user/v1/app/register`,
    method: 'post',
    data
  })
}
//步数
export function activity(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/activity/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
//血压
export function bloodpre(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/bloodpre/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
//睡眠
export function sleep(data) {
  return request({
    url: SEVSRS + `/monitor/app/v1/sleep/` + data.type + '/' + data.dat,
    method: 'get',
  })
}
/**
 * 周/月每日睡眠列表（对齐 health-admin serviceLogDetail）
 * GET /monitor/v1/sleep/{userCode}/{type}/daily-list/{day}
 * @param {{ userCode: string, type: number|string, dat: string }} data type=2周/3月，dat=YYYY-MM-DD
 * @returns {Promise}
 */
export function sleepDailyList(data) {
  const userCode = encodeURIComponent(String(data.userCode || '').trim())
  return request({
    url: SEVSRS + `/monitor/v1/sleep/${userCode}/` + data.type + '/daily-list/' + data.dat,
    method: 'get',
  })
}
//紧急联系人列表
export function contacts() {
  return request({
    url: SEVSRS + `/user/v1/list/contacts`,
    method: 'get',
  })
}
//紧急联系人添加
export function addcontacts(data) {
  return request({
    url: SEVSRS + `/user/v1/save/contacts`,
    method: 'post',
    data
  })
}
//紧急联系人删除
export function deletecontacts(data) {
  return request({
    url: SEVSRS + `/user/v1/delete/contacts?id=` + data.id,
    method: 'get',
  })
}

/**
 * 家庭成员 - 发送验证码
 * GET /health/api/user/v1/app/family/pin?phone=xxx
 * @param {string} phone 家属手机号
 * @returns {Promise}
 */
export function familyPin(phone) {
  return request({
    url: SEVSRS + `/user/v1/app/family/pin?phone=` + encodeURIComponent(String(phone || '').trim()),
    method: 'get',
    noLoading: true
  })
}

/**
 * 家庭成员 - 添加
 * POST /health/api/user/v1/app/family/add
 * @param {{familyName:string,familyRelation:string,familyPhone:string,pin:string}} data
 * @returns {Promise}
 */
export function familyAdd(data) {
  return request({
    url: SEVSRS + `/user/v1/app/family/add`,
    method: 'post',
    data
  })
}

/**
 * 家庭成员 - 列表
 * GET /health/api/user/v1/app/family/list
 * @returns {Promise}
 */
export function familyList() {
  return request({
    url: SEVSRS + `/user/v1/app/family/list`,
    method: 'get'
  })
}

/**
 * 家庭成员 - 删除
 * GET /health/api/user/v1/app/family/delete?id=xxx
 * @param {{id:string|number}} data
 * @returns {Promise}
 */
export function familyDelete(data) {
  return request({
    url: SEVSRS + `/user/v1/app/family/delete?id=` + data.id,
    method: 'get'
  })
}

/**
 * 家庭成员 - 切换账号
 * POST /health/api/user/v1/app/family/switch-account
 * @param {{targetUserCode:string}} data
 * @returns {Promise}
 */
export function familySwitchAccount(data) {
  return request({
    url: SEVSRS + `/user/v1/app/family/switch-account`,
    method: 'post',
    data
  })
}

/**
 * 家庭成员 - 更新关系/姓名
 * POST /health/api/user/v1/app/family/update-relation
 * @param {{id:string|number,familyRelation?:string,familyName?:string}} data
 * @returns {Promise}
 */
export function familyUpdateRelation(data) {
  return request({
    url: SEVSRS + `/user/v1/app/family/update-relation`,
    method: 'post',
    data
  })
}
//个人资料
export function health(data) {
  return request({
    url: SEVSRS + `/user/v1/health`,
    method: 'get',
  })
}
//编辑个人资料
export function uphealthinfo(data) {
  return request({
    url: SEVSRS + `/user/v1/up-health-info`,
    method: 'post',
    data
  })
}
//编辑个人资料
export function uphealthinfo2(data) {
  return request({
    url: SEVSRS + `/user/v2/up-health-info`,
    method: 'post',
    data
  })
}
// 用户设备绑定
export function binddevice(data) {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device?bindStatus=` + data.bindStatus + '&deviceCode=' + data.deviceCode + '&deviceType=' + data.deviceType + '&jsonBrs=' + data.jsonBrs,
    method: 'get',
  })
}
// 查询用户设备绑定
export function isbind(data) {
  return request({
    url: SEVSRS + `/device/v1/app/is-bind`,
    method: 'get',
  })
}
// 设备列表
export function devicelist(data) {
  return request({
    url: SEVSRS + `/device/v1/device-list`,
    method: 'get',
  })
}
// 设备绑定信息
export function binddeviceinfo() {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device-info`,
    method: 'get',
  })
}

/**
 * 获取用户已绑定设备列表
 * @param {Object} params - 请求参数
 * @param {String} params.parentDeviceType - 父级设备类型（可选）
 * @returns {Promise} 返回设备列表
 */
export function getBindDeviceList(params = {}) {
  return request({
    url: SEVSRS + `/device/v1/app/bind-device-list`,
    method: 'get',
    params
  })
}
// 设备解绑
export function unbindbinddevice(data) {
  return request({
    url: SEVSRS + `/device/v1/app/unbind-bind-device?bindStatus=` + data.bindStatus + '&deviceCode=' + data.deviceCode + '&userCode=' + data.userCode + '&deviceType=' + data.deviceType,
    method: 'get',
  })
}
// 心电列表
export function findecglist(data) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-list?dayDate=` + data.dayDate,
    method: 'get',
  })
}
/**
 * 手表ECG分页列表（不限日期）
 * @param {Object} params
 * @param {number} params.pn - 页码，从1开始
 * @param {number} params.ps - 每页大小
 */
export function findEcgListPage(params) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-list-page`,
    method: 'get',
    params
  })
}
export function findecginfo(data) {
  return request({
    url: SEVSRS + `/monitor/v1/app/find-ecg-info?ecgId=` + data.ecgId,
    method: 'get',
  })
}

/**
 * 根据测量日期和用户编码查询心电仪器测量记录
 * @param {Object} params - 请求参数
 * @param {String} params.measurementDate - 测量日期（格式：yyyy-MM-dd）
 * @param {String} params.userCode - 用户编码
 */
export function getSwkMeasurementRecords(params) {
  return request({
    url: SEVSRS + `/swk-ecg/v1/measurements/by-date-user`,
    method: 'get',
    params
  })
}

/**
 * 数维康心电-根据用户编码分页查询测量记录（简化版，不限日期）
 * @param {Object} params
 * @param {string} params.userCode - 用户编码（必填）
 * @param {number} params.pageIndex - 页码，从1开始（可选，默认1）
 * @param {number} params.pageSize - 每页数量（可选，默认20）
 */
export function getSwkMeasurementsByUser(params) {
  return request({
    url: SEVSRS + `/swk-ecg/v1/measurements/by-user`,
    method: 'get',
    params
  })
}
export function rulesName(data) {
  return request({
    url: SEVSRS + `/rule-conf/v1/rules/34`,
    method: 'get',
  })
}
export function mearecordlist(data) {
  return request({
    url: SEVSRS + `/monitor/v1/mea-record-list`,
    method: 'post',
    data
  })
}
export function savemearecord(data) {
  return request({
    url: SEVSRS + `/monitor/v1/save-mea-record`,
    method: 'post',
    data
  })
}
export function logout(data) {
  return request({
    url: SEVSRS + `/user/v1/account/logout?pin=` + data.pin,
    method: 'get',
  })
}

/**
 * APP 退出账号（仅失效当前 token，账号保留）
 * POST /health/api/user/v2/app/sign-out
 * @returns {Promise}
 */
export function appSignOut() {
  return request({
    url: SEVSRS + `/user/v2/app/sign-out`,
    method: 'post'
  })
}

/**
 * APP 注销账号（校验验证码后软删除账号）
 * POST /health/api/user/v2/app/delete-account?pin=xxx
 * @param {{ pin: string }} data
 * @returns {Promise}
 */
export function appDeleteAccount(data) {
  return request({
    url: SEVSRS + `/user/v2/app/delete-account?pin=${encodeURIComponent(String(data.pin || '').trim())}`,
    method: 'post'
  })
}
export function medicaltag() {
  return request({
    url: SEVSRS + `/common/v1/medical/tag`,
    method: 'get',
  })
}

/**
 * 获取医疗标签数据
 * @param {Object} params - 请求参数
 * @param {string} params.type - 疾病类型：1001-普通疾病、2001-家族史疾病、3001-精神类疾病
 * @param {number} params.gender - 性别限制：0-无限制，1-男性用户才显示，2-女性用户才显示
 */
export function getMedicalTag(params) {
  return request({
    url: SEVSRS + `/common/v1/medical/tag`,
    method: 'get',
    params
  })
}
export function v2uphealthinfo(data) {
  return request({
    url: SEVSRS + `/user/v2/up-health-info`,
    method: 'post',
    data
  })
}
/**
 * 获取用户医疗标签数据
 * @param {Object} params - 请求参数
 * @param {string} params.type - 疾病类型：1001-个人史、2001-家族史、3001-精神类疾病
 */
export function getUserMedicalTag(params) {
  return request({
    url: SEVSRS + `/user/v1/user-medical-tag`,
    method: 'get',
    params
  })
}

/**
 * 根据经纬度查询地址（输入 GCJ-02 火星坐标）
 * @param {Object} data - 请求体
 * @param {number} data.lat - 纬度（GCJ-02）
 * @param {number} data.lon - 经度（GCJ-02）
 * @param {string} [data.address] - 地址（可选）
 * @param {string} [data.imei] - 设备编码（可选）
 * @returns {Promise<{code:string|number,msg:string|null,data:{address:string,latitude:number,longitude:number}|null}>}
 */
export function findAddress(data) {
  return request({
    url: SEVSRS + `/case/v1/app/findAddress`,
    method: 'post',
    data
  })
}

/**
 * 获取跳转链接
 * @param {Object} data - 请求参数
 * @param {number} data.type - 类型：1-视频医生，2-图文医生，3-电话医生，45-购药商城
 */
export function getJumpUrl(data) {
  return request({
    url: SEVSRS + `/online-doctor/v1/get-jump-url`,
    method: 'post',
    data
  })
}

/**
 * 微信小程序 web-view：获取跳转互联网医院购药小程序所需参数（依赖登录态，请求体为空对象）
 * @see `/health/api/online-doctor/v1/get-wechat-mini-program-jump-param`
 * @returns {Promise}
 */
export function getWechatMiniProgramJumpParam() {
  return request({
    url: SEVSRS + `/online-doctor/v1/get-wechat-mini-program-jump-param`,
    method: 'post',
    data: {},
    noLoading: true
  })
}

/**
 * 记录用户点击
 * @param {Object} data - 参数对象
 * @param {string} data.moduleName - 模块编码：GRAPHIC_DOCTOR(图文医生)、VIDEO_DOCTOR(视频医生)、PHONE_DOCTOR(电话医生)、PHARMACY_MALL(购药商城)、OUTPATIENT_COLLABORATION(门诊协作)、HEALTH_CHECK(健康查一查)、HEALTH_CONSULTATION(健康咨询)
 * @param {string} data.accessTime - 访问时间，格式 yyyy-MM-dd HH:mm:ss，可选，不传则后端默认当前时间
 */
export function recordUserAccess(data) {
  return request({
    url: SEVSRS + '/access-record/v1/record',
    method: 'post',
    data,
    noLoading: true // 不显示loading，因为这是后台记录接口
  })
}

/**
 * 查询血压仪设备测量数据
 * @param {Object} data - 请求参数
 * @param {string} data.queryType - 查询类型：SINGLE_DAY（单天）、MULTIPLE_DAYS（多天）
 * @param {string} data.queryDate - 单天查询日期，格式：yyyy-MM-dd
 * @param {string} data.startDate - 多天查询开始日期，格式：yyyy-MM-dd
 * @param {string} data.endDate - 多天查询结束日期，格式：yyyy-MM-dd
 */
export function queryBloodPressureMonitor(data) {
  return request({
    url: SEVSRS + `/blood-pressure-monitor/v1/query-blood-pressure`,
    method: 'post',
    data
  })
}

/**
 * 查询权益使用统计（已用次数 / 是否还可继续使用）
 * @param {Object} params - 查询参数
 * @param {number|string} params.productId - 产品 ID（用户权益中的 productId）
 * @param {string} params.caseType - 案件类型 / 权益项 source_id 字符串
 * @returns {Promise<{code:string|number,msg:string|null,data:{usedCount:number,billingType:number|null,timesCount:number|null,feeAmount:number|null,billingText:string|null,billingDisplay:string|null,canUse:boolean}|null}>}
 */
export function getEquityUsedCount(params) {
  return request({
    url: SEVSRS + `/case/v1/app/equity-used-count`,
    method: 'get',
    params,
    noLoading: true
  })
}

/**
 * 提交一键救援信息
 * @param {Object} data - 请求参数
 * @param {number} data.lat - 纬度（GCJ-02坐标系，火星坐标系）
 * @param {number} data.lon - 经度（GCJ-02坐标系，火星坐标系）
 * @param {string} data.address - 详细地址信息（必填）
 * @param {string} [data.imei] - 设备编码（可选）
 * @param {string} [data.caseType] - 案件类型 / 权益项 source_id（可选，不传默认 110）
 * @param {number} [data.usedCount] - 已使用次数（建议取自 equity-used-count）
 * @param {number} [data.billingType] - 1-计次 2-计费 3-文本
 * @param {number} [data.timesCount] - 计次总次数
 * @param {number} [data.feeAmount] - 计费金额
 * @param {string} [data.billingText] - 计量文本
 * @param {string} [data.billingDisplay] - 展示文案
 * @param {boolean} [data.canUse] - 是否还可继续使用
 * @returns {Promise} 返回Promise对象
 */
export function submitRescue(data) {
  return request({
    url: SEVSRS + `/case/v1/app/rescue`,
    method: 'post',
    data
  })
}

/**
 * 查询当前用户收货地址列表
 * @returns {Promise}
 */
export function deliveryAddressList() {
  return request({
    url: SEVSRS + `/user/v1/list/delivery-address`,
    method: 'get'
  })
}

/**
 * 添加用户收货地址
 * @param {Object} data
 * @param {string} data.receiverName 收货人姓名
 * @param {string} data.receiverPhone 收货人电话
 * @param {string} data.detailAddress 详细地址
 * @param {boolean} [data.isDefault] 是否设为默认地址
 * @returns {Promise}
 */
export function saveDeliveryAddress(data) {
  return request({
    url: SEVSRS + `/user/v1/save/delivery-address`,
    method: 'post',
    data
  })
}

/**
 * 编辑用户收货地址
 * @param {Object} data
 * @param {number|string} data.id 收货地址 ID
 * @param {string} data.receiverName 收货人姓名
 * @param {string} data.receiverPhone 收货人电话
 * @param {string} data.detailAddress 详细地址
 * @param {boolean} [data.isDefault] 是否设为默认地址
 * @returns {Promise}
 */
export function updateDeliveryAddress(data) {
  return request({
    url: SEVSRS + `/user/v1/update/delivery-address`,
    method: 'post',
    data
  })
}

/**
 * 设置默认收货地址
 * @param {number|string} id 收货地址 ID
 * @returns {Promise}
 */
export function setDefaultDeliveryAddress(id) {
  return request({
    url: SEVSRS + `/user/v1/set-default/delivery-address?id=${id}`,
    method: 'get'
  })
}

/**
 * 删除用户收货地址
 * @param {number|string} id 收货地址 ID
 * @returns {Promise}
 */
export function deleteDeliveryAddress(id) {
  return request({
    url: SEVSRS + `/user/v1/delete/delivery-address?id=${id}`,
    method: 'get'
  })
}

/**
 * 提交健康评测
 * POST /health/api/health-evaluation/v1/submit
 * @param {Object} data
 * @returns {Promise}
 */
export function submitHealthEvaluation(data) {
  return request({
    url: SEVSRS + `/health-evaluation/v1/submit`,
    method: 'post',
    data
  })
}

/**
 * 查询最新健康评测结果
 * GET /health/api/health-evaluation/v1/latest
 * @returns {Promise}
 */
export function getLatestHealthEvaluation() {
  return request({
    url: SEVSRS + `/health-evaluation/v1/latest`,
    method: 'get'
  })
}

/**
 * 按 ID 查询健康评测结果
 * GET /health/api/health-evaluation/v1/detail/{id}
 * @param {string|number} id
 * @returns {Promise}
 */
export function getHealthEvaluationDetail(id) {
  return request({
    url: SEVSRS + `/health-evaluation/v1/detail/${id}`,
    method: 'get'
  })
}

/**
 * 是否已完成健康评测
 * GET /health/api/health-evaluation/v1/status
 * @returns {Promise}
 */
export function getHealthEvaluationStatus() {
  return request({
    url: SEVSRS + `/health-evaluation/v1/status`,
    method: 'get'
  })
}

/**
 * 查询健康日报 V2
 * GET /health/api/health-report/v2/daily
 * @param {{ reportDate?: string }} [params]
 * @returns {Promise}
 */
export function getHealthReportDailyV2(params) {
  return request({
    url: SEVSRS + `/health-report/v2/daily`,
    method: 'get',
    params
  })
}

/**
 * 查询健康周报 V2
 * GET /health/api/health-report/v2/weekly
 * @param {{ reportDate?: string }} [params]
 * @returns {Promise}
 */
export function getHealthReportWeeklyV2(params) {
  return request({
    url: SEVSRS + `/health-report/v2/weekly`,
    method: 'get',
    params
  })
}

/**
 * 查询当周 V2 健康评分（周一至周日逐日评分）
 * GET /health/api/health-score/v2/weekly
 * @param {{ scoreDate?: string }} [params]
 * @returns {Promise}
 */
export function getHealthScoreWeeklyV2(params) {
  return request({
    url: SEVSRS + `/health-score/v2/weekly`,
    method: 'get',
    params
  })
}

/**
 * 查询健康日报 V2 列表
 * GET /health/api/health-report/v2/daily/list
 * @param {{ startDate?: string, endDate?: string, pn?: number, ps?: number }} [params]
 * @returns {Promise}
 */
export function getHealthReportDailyV2List(params) {
  return request({
    url: SEVSRS + `/health-report/v2/daily/list`,
    method: 'get',
    params
  })
}

/**
 * 查询健康周报 V2 列表
 * GET /health/api/health-report/v2/weekly/list
 * @param {{ startDate?: string, endDate?: string, pn?: number, ps?: number }} [params]
 * @returns {Promise}
 */
export function getHealthReportWeeklyV2List(params) {
  return request({
    url: SEVSRS + `/health-report/v2/weekly/list`,
    method: 'get',
    params
  })
}

/**
 * 查询健康日报 V2 详情（按快照 ID）
 * GET /health/api/health-report/v2/daily/detail/{reportId}
 * @param {string|number} reportId
 * @returns {Promise}
 */
export function getHealthReportDailyV2Detail(reportId) {
  return request({
    url: SEVSRS + `/health-report/v2/daily/detail/${reportId}`,
    method: 'get'
  })
}

/**
 * 查询健康周报 V2 详情（按快照 ID）
 * GET /health/api/health-report/v2/weekly/detail/{reportId}
 * @param {string|number} reportId
 * @returns {Promise}
 */
export function getHealthReportWeeklyV2Detail(reportId) {
  return request({
    url: SEVSRS + `/health-report/v2/weekly/detail/${reportId}`,
    method: 'get'
  })
}

/**
 * 标记健康报告 V2 为已读（日报 / 周报同一表，按主键）
 * POST /health/api/health-report/v2/read/{reportId}
 * @param {string|number} reportId 快照 ID
 * @returns {Promise}
 */
export function markHealthReportV2AsRead(reportId) {
  return request({
    url: SEVSRS + `/health-report/v2/read/${encodeURIComponent(String(reportId))}`,
    method: 'post'
  })
}

/**
 * 查询健康报告 V2 未读统计
 * GET /health/api/health-report/v2/query/unread
 * @param {{ userCode?: string }} [params]
 * @returns {Promise}
 */
export function getHealthReportV2Unread(params) {
  return request({
    url: SEVSRS + `/health-report/v2/query/unread`,
    method: 'get',
    params
  })
}

/**
 * 善行医疗：强制登录刷新 Token
 * POST /health/api/benefm/login
 * @returns {Promise}
 */
export function benefmLogin() {
  return request({
    url: SEVSRS + `/benefm/login`,
    method: 'post'
  })
}

/**
 * 善行医疗：分页查询活动报告列表
 * GET /health/api/benefm/reports
 * @param {Object} [params]
 * @param {number} [params.page] 页码，默认 1
 * @param {number} [params.size] 每页条数，默认 10
 * @param {string} [params.phone] 手机号
 * @param {string} [params.userName] 患者姓名
 * @param {number} [params.leadNum] 导联数：1=单导心电贴，8=12导心电衣
 * @param {number} [params.reportFinalStatus] 报告状态：0未生成/2已生成/3取消/4放弃
 * @param {string} [params.uploadStartTime] 上传开始日期 yyyy-MM-dd
 * @param {string} [params.uploadEndTime] 上传结束日期 yyyy-MM-dd
 * @param {string} [params.collectStartTime] 采集开始日期 yyyy-MM-dd
 * @param {string} [params.collectEndTime] 采集结束日期 yyyy-MM-dd
 * @returns {Promise}
 */
export function getBenefmReports(params) {
  return request({
    url: SEVSRS + `/benefm/reports`,
    method: 'get',
    params
  })
}

/**
 * 善行医疗：查看报告 PDF（返回可访问链接）
 * GET /health/api/benefm/reports/pdf
 * @param {Object} params
 * @param {number|string} params.reportId 报告 ID
 * @returns {Promise}
 */
export function getBenefmReportPdf(params) {
  return request({
    url: SEVSRS + `/benefm/reports/pdf`,
    method: 'get',
    params
  })
}

/**
 * 上传体检/图片文件（支持 dataURL base64）
 * POST /health/api/files/v1/upload/examination-file
 * @param {Object} data
 * @param {string} data.file data:image/png;base64,... 或可访问文件地址
 * @returns {Promise}
 */
export function uploadExaminationFile(data) {
  return request({
    url: SEVSRS + `/files/v1/upload/examination-file`,
    method: 'post',
    data,
    noLoading: true
  })
}




// WEBPACK FOOTER //
// ./src/api/activity.js